import { useMemo } from 'react';

//* Context
import { withLanguageContext } from '@/context';

//* Components
import CustomLink from '../CustomLink';

//* Styles
import ButtonStyle from './style';

const Button = ({ btnType, text, className, onClick, url, translate, type = 'button', disabled = false, children, external = false, ariaLabel }) => {
	const Component = useMemo(() => (url ? CustomLink : 'button'), [url]);
	const customProps = useMemo(() => (url ? { url, external } : { type, disabled }), [url, external, type, disabled]);

	let btn;

	switch (btnType) {
		default:
			btn = (
				<ButtonStyle
					onClick={onClick || null}
					className={`btn ${className || ''} ${disabled ? 'disabled' : ''}`}>
					<Component
						{...ariaLabel}
						{...customProps}>
						{children || translate(text)}
					</Component>
				</ButtonStyle>
			);
	}

	return btn;
};

export default withLanguageContext(Button, ['translate']);
